var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup1715OnTheWaitList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 207,
    viewBox: "0 0 199 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2953 90.1199L0 189.415H99.2953H198.591L99.2953 90.1199Z",
    fill: "#FFD31F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2958 159.743C137.747 159.743 168.919 128.571 168.919 90.1198C168.919 51.6681 137.747 20.4968 99.2958 20.4968C60.8441 20.4968 29.6729 51.6681 29.6729 90.1198C29.6729 128.571 60.8441 159.743 99.2958 159.743Z",
    fill: "#006EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2955 140.968C127.378 140.968 150.144 118.203 150.144 90.1199C150.144 62.0373 127.378 39.2717 99.2955 39.2717C71.2128 39.2717 48.4473 62.0373 48.4473 90.1199C48.4473 118.203 71.2128 140.968 99.2955 140.968Z",
    fill: "#6BB6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2958 123.068C117.493 123.068 132.244 108.316 132.244 90.1198C132.244 71.923 117.493 57.1716 99.2958 57.1716C81.099 57.1716 66.3477 71.923 66.3477 90.1198C66.3477 108.316 81.099 123.068 99.2958 123.068Z",
    fill: "#006EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2949 107.047C108.644 107.047 116.223 99.4687 116.223 90.1198C116.223 80.7709 108.644 73.1921 99.2949 73.1921C89.946 73.1921 82.3672 80.7709 82.3672 90.1198C82.3672 99.4687 89.946 107.047 99.2949 107.047Z",
    fill: "#6BB6FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.525 139.355C135.927 151.953 118.521 159.748 99.2957 159.748C80.0701 159.748 62.6644 151.958 50.0664 139.355L99.2957 90.1252L148.525 139.355Z",
    fill: "#6BB6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.525 139.355C135.927 151.953 118.521 159.748 99.2957 159.748C80.0701 159.748 62.6644 151.958 50.0664 139.355L99.2957 90.1252L148.525 139.355Z",
    fill: "#091F83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.248 126.072C126.04 135.28 113.339 140.968 99.296 140.968C85.253 140.968 72.5518 135.28 63.3438 126.072L99.296 90.1199L135.248 126.072Z",
    fill: "#006EF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.59 113.42C116.625 119.385 108.395 123.073 99.2955 123.073C90.1961 123.073 81.9604 119.385 76.001 113.42L99.2955 90.1252L122.59 113.42Z",
    fill: "#091F83"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.264 102.088C108.205 105.152 103.968 107.048 99.2959 107.048C94.624 107.048 90.3921 105.152 87.3281 102.088L99.2959 90.1199L111.264 102.088Z",
    fill: "#006EF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.414 10.0486L101.879 83.5837L106.047 87.7516L179.582 14.2165L175.414 10.0486Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.015 87.7837L101.849 83.6116L99.5127 90.1197L106.015 87.7837Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.866 12.8372L166.131 23.5012L173.671 15.9609L169.412 5.2915L161.866 12.8372Z",
    fill: "#6BB6FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.392 20.3123L158.656 30.9763L166.196 23.4306L161.937 12.7666L154.392 20.3123Z",
    fill: "#006EF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.795 27.7655L166.131 23.501L173.671 15.9607L184.335 20.2198L176.795 27.7655Z",
    fill: "#006EF5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32 35.2407L158.656 30.9762L166.197 23.4304L176.866 27.6949L169.32 35.2407Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.591 189.415H0V207H198.591V189.415Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.108 0V13.7877H98.917V0H100.108Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9383 11.6702L61.8322 23.6108L60.8011 24.2061L53.9072 12.2655L54.9383 11.6702Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6529 44.3569L33.5935 51.2508L32.9983 52.2819L21.0576 45.388L21.6529 44.3569Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17578 89.3125H22.9635V90.5031H9.17578V89.3125Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup1715OnTheWaitList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group1715_OnTheWaitList.51a0d635712d5f7a479a64abd3b1f381.svg";